import React, { ReactNode } from 'react';
import styles from './FloButtonTabs.module.css';
import { Row, Col, Button } from 'react-bootstrap';
import classnames from 'classnames';
import { FloComponentProps } from 'components';

type TabDefinition = {
  id:       string,
  label:    (isActive: boolean) => string | ReactNode,
}

type HeaderItemProps = {
  tab: TabDefinition,
  isActive: boolean,
  onSelect: (id: string) => void,
}

const HeaderItem: React.FC<HeaderItemProps> = React.memo(({tab, isActive, onSelect}) => (
  <Button
    onClick={() => onSelect(tab.id)}
    className={classnames(styles.headerItem, { [styles.isActive]: isActive })}
  >
    {tab.label(isActive)}
  </Button>
));

type HeaderProps = {
  tabs: TabDefinition[],
  name: string,
  selected: string,
  onSelect: (id: string) => void,
}

const Header: React.FC<HeaderProps> = React.memo(({tabs, name, selected, ...rest}) => (
  <Row>
    <Col xs="12" className={styles.header}>
      <div className={styles.headerItemWrapper}>
      { tabs.map(tab => (<HeaderItem {...rest} key={`${name}-item-${tab.id}`} tab={tab} isActive={tab.id === selected} />)) }
      </div>
    </Col>
  </Row>
));

interface FloButtonTabsProps extends FloComponentProps {
  tabs:     TabDefinition[];
  children: ReactNode;
  selected: string;
  onSelect: (id: string) => void;
}

export const FloButtonTabs: React.FC<FloButtonTabsProps> = React.memo(({
  name = 'flo-button-tabs',
  className,
  children,
  ...rest
}) => {
  return (
    <Row className={classnames(styles.root, className)}>
      <Col xs="12">
        <Header {...rest} name={name} />
        <Row>
          <Col xs="12">
            {children}
          </Col>
        </Row>
      </Col>
    </Row>
  );
});

export default FloButtonTabs;